import { Fund } from './fund';
import { Type } from './type';

export interface FundSupportType {
  description?: string;
  fund?: Fund;
  fundId?: number;
  id?: number;
  type?: Type;
  typeId?: number;
}
